// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './lib/css'
import './lib/script'
import './lib/global'

import Vue from 'vue'
import App from './App'
import router from './router'
import EventBus from './lib/eventBus.js'
import axios from 'axios'
import store from './vuex/store'
// import { BootstrapVue } from 'bootstrap-vue'
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'

// Vue.use(BootstrapVue)

import vSelect from 'vue-select'
Vue.component('v-select', vSelect)
import 'vue-select/dist/vue-select.css'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
Vue.use(Loading, {
  container: null, // this.$refs.loadingContainer,
  canCancel: false,
  // onCancel: this.yourMethodName,
  color: 'red',
  loader: 'bars', // spinner or dots or bars
  width: 84,
  height: 84,
  backgroundColor: '#ffffff',
  opacity: 0.8,
  zIndex: 999,
  transition: 'fade'
  // is-full-page: true
  // active: true
})

import 'chart.js'
import 'hchs-vue-charts'
Vue.use(window.VueCharts)

if (localStorage.token) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.token
}
// axios.defaults.baseURL = 'https://demo.micromuneem.com/backend/api'
// axios.defaults.baseURL = 'https://demo.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://superbond.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://gnl.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://app.surahafinance.com/backend/api'
// axios.defaults.baseURL = 'https://swapnashikha.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://pushpak.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://surendra.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://smfcash.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://demo.incrediblemicro.com/backend/api'
// axios.defaults.baseURL = 'https://app.aonemicrofinance.com/backend/api'
// axios.defaults.baseURL = 'https://mahilasakti.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://bullet.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://microfinance.smegrowthmicrofoundation.com/backend/api'
// axios.defaults.baseURL = 'https://utkrastmf.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://siyamicro.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://gagret.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://aglfmfi.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://aglfoundation.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://pava.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://mrp.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://app.dotinfinance.com/backend/api'
// axios.defaults.baseURL = 'https://rkc.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://shorishahahfinance.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://swapnapurti.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://jansuvidha.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://udaanlo.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://fingold.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://rewadi.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://app.eonmicrofinance.com/backend/api'
// axios.defaults.baseURL = 'https://dazzelloans.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://manisha.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://guddu.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://app.finmoneymicro.com/backend/api'
// axios.defaults.baseURL = 'https://app.zascofinance.com/backend/api'
// axios.defaults.baseURL = 'https://youfirst.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://helpgroup.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://simanchal.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://raghunandan.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://jsavior.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://siddhi.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://app.supergoldmicro.com/backend/api'
// axios.defaults.baseURL = 'https://app.worthrichmicrofinance.com/backend/api'
// axios.defaults.baseURL = 'https://raunak.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://ekam.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://laxminivas.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://manaina.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://dhanvarsha.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://pblmilap.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://udyog.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://twink.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://ommsai.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://auc.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://laxmi.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://tripursundari.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://shreenidhi.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://mtfs.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://lm.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://rkseva.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://nsg.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://dhanush.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://a1secure.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://growth.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://shrimangal.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://shrisai.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://savera.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://arshgroups.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://benstar.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://hooda.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://jcramg.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://gramin.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://multiple.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://khushpratap.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://goldway.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://klomshy.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://pankajsairam.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://arihant.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://sitara.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://shreeganesh.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://shreeganesh.microfinsoftware.com/backend/api'
// axios.defaults.baseURL = 'https://shreya.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://diamond.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://magicgallery.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://mauli.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://rsr.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://tridev.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://supergsg.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://khushi.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://mks.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://hst.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://darshika.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://virat.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://rockmount.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://ghoomar.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://mitrsewa.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://jeevika.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://star.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://goldindia.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://quickpahal.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://finbase.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://aadharshila.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://dspl.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://dhanratna.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://dhairya.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://unnati.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://sakhi.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://rdbi.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://jts.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://hoodafinancehrm.com/backend/api'
// axios.defaults.baseURL = 'https://swaraj.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://radhaiurban.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://finmantra.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://kiran.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://mj.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://vardaan999.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://er.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://vda.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://bm.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://incredible.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://mfutkrast.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://kakasastore.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://parangat.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://aviral.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://manikanta.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://progati.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://progati.micromuneem.com/backend/api'
// axios.defaults.baseURL = 'https://goldwayfinance.in/backend/api'
// axios.defaults.baseURL = 'https://jansathimf.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://dgmf.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://bmcf.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://prathanam.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://divine.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://mahotsav.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://janashakti.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://almf.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://triplambed.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://sgfc.microfinsoftware.com/backend/api'
// axios.defaults.baseURL = 'https://bpn.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://fundwell.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://kanakprit.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://supervisionmf.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://rmfs.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://vedantindia.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://rt.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://ts.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://nkc.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://ms.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://usfinance.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://growwell.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://svr.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://janbhawna.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://anand.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://dmf.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://janchetna.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://harshvardhan.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://fincare.13squad.com/backend/api'
// axios.defaults.baseURL = 'https://esb.microfinsoftware.com/backend/api'
// axios.defaults.baseURL = 'https://helpindia.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://demo.microfinsoftware.com/backend/api'
// axios.defaults.baseURL = 'https://yatricapital.microfinsoftware.com/backend/api'
// axios.defaults.baseURL = 'https://postpy.microfinsoftware.com/backend/api'
// axios.defaults.baseURL = 'https://grouploan.microfinsoftware.com/backend/api'
// axios.defaults.baseURL = 'https://mrpgrowth.microfinsoftware.com/backend/api'
// axios.defaults.baseURL = 'https://dhanmitra.microfinsoftware.com/backend/api'
// axios.defaults.baseURL = 'https://janaadarsh.microfinsoftware.com/backend/api'
// axios.defaults.baseURL = 'https://rbsr.microfinsoftware.com/backend/api'
// axios.defaults.baseURL = 'https://shreeram.microfinsoftware.com/backend/api'
// axios.defaults.baseURL = 'https://gramsevamicrofinance.com/backend/api'
// axios.defaults.baseURL = 'https://sarthi.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://ujjalsansar.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://pfs.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://loknidhi.microfinsoftware.com/backend/api'
// axios.defaults.baseURL = 'https://rsw.microfinsoftware.com/backend/api'
// axios.defaults.baseURL = 'https://kktrading.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://gcf.microfinsoftware.com/backend/api'
// axios.defaults.baseURL = 'https://finroute.microfinsoftware.com/backend/api'
// axios.defaults.baseURL = 'https://vistara.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://netbanking.mykisok.com/backend/api'
// axios.defaults.baseURL = 'https://daivik.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://muldhan.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://usfinance.microfinsoftware.com/backend/api'
// axios.defaults.baseURL = 'https://mehndiratta.microfinsoftware.com/backend/api'
// axios.defaults.baseURL = 'https://everyone.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://aa2.microfinsoftware.com/backend/api'
// axios.defaults.baseURL = 'https://ecfs.microfinsoftware.com/backend/api'
// axios.defaults.baseURL = 'https://sanidhyafincorp.com/backend/api'
// axios.defaults.baseURL = 'https://arv.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://app.unicelruralcreditcare.com/backend/api'
// axios.defaults.baseURL = 'https://laxmidhan.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://quickmoney.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://lmitra.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://mf.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://diksharth.microfinsoftware.com/backend/api'
// axios.defaults.baseURL = 'https://maan.microfinsoftware.com/backend/api'
// axios.defaults.baseURL = 'https://kgf.microfinsoftware.com/backend/api'
// axios.defaults.baseURL = 'https://moon.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://aryansh.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://app.onevisionmicrofinance.com/backend/api'
// axios.defaults.baseURL = 'https://manokamana.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://shreejee.microfinsoftware.com/backend/api'
// axios.defaults.baseURL = 'https://adss.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://growth.microfinsoftware.com/backend/api'
// axios.defaults.baseURL = 'https://prithvicapital.microfinsoftware.com/backend/api'
// axios.defaults.baseURL = 'https://piyush.microfinsoftware.com/backend/api'
// axios.defaults.baseURL = 'https://aasv.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://mitrsewa.microfinsoftware.com/backend/api'
// axios.defaults.baseURL = 'https://achuthanand.microfinancesoftware.in/backend/api'
// axios.defaults.baseURL = 'https://pratik.microfinsoftware.com/backend/api'
// axios.defaults.baseURL = 'https://app.frontlinemicrope.com/backend/api'
// axios.defaults.baseURL = 'https://mahaselfhelp.microfinsoftware.com/backend/api'
// axios.defaults.baseURL = 'https://instant.microfinsoftware.com/backend/api'
// axios.defaults.baseURL = 'https://jkmf.microfinsoftware.com/backend/api'
axios.defaults.baseURL = 'https://pragati.microfinsoftware.com/backend/api'

Vue.prototype.$bus = EventBus
Vue.prototype.$http = axios
Vue.prototype.$axios = axios
// window.axios = require('axios')
// Vue.use(axios)
import { Form, HasError, AlertError } from 'vform'
window.Form = Form
Vue.component(HasError.name, HasError)
Vue.component(AlertError.name, AlertError)

// import vue-good-table
import VueGoodTablePlugin from 'vue-good-table'
// import the styles
import 'vue-good-table/dist/vue-good-table.css'
Vue.use(VueGoodTablePlugin)
import moment from 'moment'

Vue.filter('myDate', function (created) {
  return moment(created).format('DD-MM-YYYY')
})

Vue.filter('myYMDDate', function (created) {
  return moment(created).format('DD-MM-YYYY')
})

import Swal from 'sweetalert2'
const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 2000,
  timerProgressBar: true,
  onOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  }
})
window.Toast = Toast
window.Swal = Swal

window.Fire = new Vue()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})




// WEBPACK FOOTER //
// ./src/main.js